<template>
	<div>
		<locum-booking-rejected />
		<locum-upcoming-bookings />
		<locum-past-bookings />
		<locum-increase-availability-ad />
	</div>
</template>

<script>
import LocumBookingRejected from '@/components/ui/dashboard/locum/cards/LocumBookingRejected';
import LocumUpcomingBookings from '@/components/ui/dashboard/locum/dropdowns/LocumUpcomingBookings';
import LocumPastBookings from '@/components/ui/dashboard/locum/dropdowns/LocumPastBookings';
import LocumIncreaseAvailabilityAd from '@/components/ui/dashboard/locum/cards/LocumIncreaseAvailabilityAd';

export default {
	name: 'LocumSuccessBookingConfirmed',
	components: {
		LocumBookingRejected,
		LocumUpcomingBookings,
		LocumPastBookings,
		LocumIncreaseAvailabilityAd,
	},
	data: () => ({}),
};
</script>
